import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { VelocityTransitionGroup } from 'velocity-react'
import classNames from 'classnames/bind'

import './ToggledContentWrapper.scss'
import { ContentBlock } from 'components/ContentBlock'

class ToggledContentWrapper extends Component {
	state = {
		expanded: this.props.expanded,
		toggleLabel: !this.props.expanded
	}

	handleClick = () => this.setState({ expanded: !this.state.expanded })

	render({ expanded, toggleLabel } = this.state, { label, attachToNextBlock } = this.props) {
		return(
			<ContentBlock
				style={{ position: 'relative' }}
				className={classNames('toggle-content-wrapper', { 'toggle-content-closed': !expanded && attachToNextBlock })}>
				<div onClick={this.handleClick} className={classNames('container-section-switcher', { expanded: expanded })}>
					<button className='btn-section-switcher' />
					{(!expanded && toggleLabel && label) && <p>{label}</p>}
				</div>
				<VelocityTransitionGroup
					enter={{
						animation: 'slideDown',
						begin: () => this.setState({ toggleLabel: false })
					}}
					leave={{
						animation: 'slideUp',
						complete: () => this.setState({ toggleLabel: true })
					}}
				>
					{this.state.expanded && <div>{this.props.children}</div>}
				</VelocityTransitionGroup>
			</ContentBlock>
		)
	}
}

ToggledContentWrapper.propTypes = {
	expanded: PropTypes.bool
}

ToggledContentWrapper.defaultProps = {
	expanded: false
}

export default ToggledContentWrapper
